module.exports = __webpack_public_path__ + "static/img/del.32e6900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/del.png
// module id = Ub/c
// module chunks = 1